import styled from "styled-components";
import { Check, X } from "lucide-react";

import { theme } from "./theme";
import { useT } from "./i18n";

// Reusable in-app confirmation for the important, hard-to-undo Front Desk v2 actions (holding eZee
// inventory, creating a booking). Mirrors the BookingDrawer askConfirm dialog. Render conditionally
// from a `dialog` state: { title, body, note, confirmLabel, onConfirm, onCancel }.
const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.55);
`;

const Card = styled.div`
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 14px;
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h3`
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  font-weight: 800;
  color: ${theme.ink};
`;

const Body = styled.div`
  font-size: 0.95rem;
  color: ${theme.ink700};
  line-height: 1.5;
`;

const Note = styled.div`
  margin-top: 0.6rem;
  padding: 0.55rem 0.7rem;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  font-size: 0.85rem;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1.1rem;
`;

const Cancel = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.5rem 0.9rem;
  border: 1px solid ${theme.border};
  border-radius: 8px;
  background: #ffffff;
  font-weight: 700;
  color: ${theme.ink700};
  cursor: pointer;
`;

const Ok = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.5rem 1rem;
  border: 0;
  border-radius: 8px;
  background: ${theme.gold};
  color: #ffffff;
  font-weight: 800;
  cursor: pointer;
  &:hover {
    background: ${theme.goldDark};
  }
`;

const ConfirmDialog = (props) => {
  const { t } = useT();
  return (
    <Backdrop onClick={props.onCancel}>
      <Card onClick={(event) => event.stopPropagation()}>
        <Title>{props.title}</Title>
        <Body>{props.body}</Body>
        {props.note ? <Note>{props.note}</Note> : null}
        <Actions>
          <Cancel type="button" onClick={props.onCancel}>
            <X size={15} /> {t("confirm_cancel")}
          </Cancel>
          <Ok type="button" onClick={props.onConfirm}>
            <Check size={15} /> {props.confirmLabel || t("confirm_ok")}
          </Ok>
        </Actions>
      </Card>
    </Backdrop>
  );
};

export default ConfirmDialog;
